// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epw-serve-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-max-width: 1120px;
  --epw-radius: 16px;
  --epw-band-bg: var(--surface-dark);
  --epw-shadow: 0 8px 28px var(--shadow);
}


    .epw-serve-page, .epw-serve-page * { box-sizing: border-box; }

    .epw-serve-page {
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      color: var(--epw-ink);
      background: var(--epw-white);
      line-height: 1.6;
    }

    .epw-serve-page { width: 100%; }

    .epw-hero {
      padding: 76px 24px 68px;
      background: var(--epw-soft);
      border-bottom: 1px solid var(--epw-line);
    }

    .epw-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      color: var(--epw-red);
      font-size: .8rem;
      font-weight: 800;
      letter-spacing: .12em;
      text-transform: uppercase;
    }

    .epw-hero h1 {
      max-width: 820px;
      margin: 0;
      font-size: clamp(2.35rem, 5vw, 4.2rem);
      line-height: 1.06;
      letter-spacing: -.04em;
    }

    .epw-hero p {
      max-width: 800px;
      margin: 22px 0 0;
      color: var(--epw-muted);
      font-size: clamp(1.06rem, 2vw, 1.22rem);
    }

    .epw-main {
      padding: 58px 24px 76px;
    }

    .epw-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 18px;
    }

    .epw-card {
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      padding: 24px;
      background: var(--epw-white);
      box-shadow: var(--epw-shadow);
    }

    .epw-card h2 {
      margin: 0 0 9px;
      font-size: 1.16rem;
    }

    .epw-card p {
      margin: 0;
      color: var(--epw-muted);
      font-size: .95rem;
    }

    .epw-usecases {
      margin-top: 52px;
      padding: 34px;
      border-radius: 20px;
      background: var(--epw-band-bg);
      color: #ffffff;
    }

    .epw-usecases h2 {
      margin: 0 0 20px;
      font-size: clamp(1.65rem, 3vw, 2.35rem);
      letter-spacing: -.025em;
    }

    .epw-usecase-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0,1fr));
      gap: 18px;
    }

    .epw-usecase {
      padding-top: 16px;
      border-top: 2px solid var(--epw-red);
    }

    .epw-usecase strong {
      display: block;
      margin-bottom: 6px;
    }

    .epw-usecase span {
      color: #d6dbe4;
      font-size: .92rem;
    }

    .epw-cta-box {
      margin-top: 50px;
      display: grid;
      grid-template-columns: minmax(0,1fr) auto;
      gap: 24px;
      align-items: center;
      padding: 30px;
      border: 1px solid var(--epw-line);
      border-radius: 18px;
    }

    .epw-cta-box h2 {
      margin: 0 0 8px;
      font-size: clamp(1.45rem, 2.5vw, 2rem);
    }

    .epw-cta-box p {
      margin: 0;
      color: var(--epw-muted);
    }

    .epw-cta {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 48px;
      padding: 0 18px;
      border-radius: 10px;
      background: var(--epw-red);
      color: var(--epw-white);
      text-decoration: none;
      font-weight: 800;
      white-space: nowrap;
    }

    .epw-cta:hover,
    .epw-cta:focus-visible {
      background: var(--epw-red-dark);
      outline: none;
    }

    @media (max-width: 900px) {
      .epw-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      .epw-usecase-grid { grid-template-columns: repeat(2, minmax(0,1fr)); }
      .epw-cta-box { grid-template-columns: 1fr; }
    }

    @media (max-width: 620px) {
      .epw-hero { padding: 54px 20px 48px; }
      .epw-main { padding: 42px 18px 58px; }
      .epw-grid,
      .epw-usecase-grid { grid-template-columns: 1fr; }
      .epw-usecases { padding: 24px; }
      .epw-cta { width: 100%; }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/WhoWeServePage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;AACxC;;;IAGI,qCAAqC,sBAAsB,EAAE;;IAE7D;MACE,uGAAuG;MACvG,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA,kBAAkB,WAAW,EAAE;;IAE/B;MACE,uBAAuB;MACvB,2BAA2B;MAC3B,wCAAwC;IAC1C;;IAEA;MACE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,sCAAsC;MACtC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,uCAAuC;IACzC;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,gDAAgD;MAChD,SAAS;IACX;;IAEA;MACE,iCAAiC;MACjC,gCAAgC;MAChC,aAAa;MACb,4BAA4B;MAC5B,6BAA6B;IAC/B;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,uCAAuC;MACvC,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;IACX;;IAEA;MACE,iBAAiB;MACjB,oCAAoC;IACtC;;IAEA;MACE,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,yCAAyC;MACzC,SAAS;MACT,mBAAmB;MACnB,aAAa;MACb,iCAAiC;MACjC,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,sCAAsC;IACxC;;IAEA;MACE,SAAS;MACT,uBAAuB;IACzB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,0BAA0B;MAC1B,uBAAuB;MACvB,qBAAqB;MACrB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;;MAEE,+BAA+B;MAC/B,aAAa;IACf;;IAEA;MACE,YAAY,gDAAgD,EAAE;MAC9D,oBAAoB,+CAA+C,EAAE;MACrE,eAAe,0BAA0B,EAAE;IAC7C;;IAEA;MACE,YAAY,uBAAuB,EAAE;MACrC,YAAY,uBAAuB,EAAE;MACrC;0BACoB,0BAA0B,EAAE;MAChD,gBAAgB,aAAa,EAAE;MAC/B,WAAW,WAAW,EAAE;IAC1B","sourcesContent":[".epw-serve-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-max-width: 1120px;\n  --epw-radius: 16px;\n  --epw-band-bg: var(--surface-dark);\n  --epw-shadow: 0 8px 28px var(--shadow);\n}\n\n\n    .epw-serve-page, .epw-serve-page * { box-sizing: border-box; }\n\n    .epw-serve-page {\n      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      line-height: 1.6;\n    }\n\n    .epw-serve-page { width: 100%; }\n\n    .epw-hero {\n      padding: 76px 24px 68px;\n      background: var(--epw-soft);\n      border-bottom: 1px solid var(--epw-line);\n    }\n\n    .epw-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      color: var(--epw-red);\n      font-size: .8rem;\n      font-weight: 800;\n      letter-spacing: .12em;\n      text-transform: uppercase;\n    }\n\n    .epw-hero h1 {\n      max-width: 820px;\n      margin: 0;\n      font-size: clamp(2.35rem, 5vw, 4.2rem);\n      line-height: 1.06;\n      letter-spacing: -.04em;\n    }\n\n    .epw-hero p {\n      max-width: 800px;\n      margin: 22px 0 0;\n      color: var(--epw-muted);\n      font-size: clamp(1.06rem, 2vw, 1.22rem);\n    }\n\n    .epw-main {\n      padding: 58px 24px 76px;\n    }\n\n    .epw-grid {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 18px;\n    }\n\n    .epw-card {\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      padding: 24px;\n      background: var(--epw-white);\n      box-shadow: var(--epw-shadow);\n    }\n\n    .epw-card h2 {\n      margin: 0 0 9px;\n      font-size: 1.16rem;\n    }\n\n    .epw-card p {\n      margin: 0;\n      color: var(--epw-muted);\n      font-size: .95rem;\n    }\n\n    .epw-usecases {\n      margin-top: 52px;\n      padding: 34px;\n      border-radius: 20px;\n      background: var(--epw-band-bg);\n      color: #ffffff;\n    }\n\n    .epw-usecases h2 {\n      margin: 0 0 20px;\n      font-size: clamp(1.65rem, 3vw, 2.35rem);\n      letter-spacing: -.025em;\n    }\n\n    .epw-usecase-grid {\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0,1fr));\n      gap: 18px;\n    }\n\n    .epw-usecase {\n      padding-top: 16px;\n      border-top: 2px solid var(--epw-red);\n    }\n\n    .epw-usecase strong {\n      display: block;\n      margin-bottom: 6px;\n    }\n\n    .epw-usecase span {\n      color: #d6dbe4;\n      font-size: .92rem;\n    }\n\n    .epw-cta-box {\n      margin-top: 50px;\n      display: grid;\n      grid-template-columns: minmax(0,1fr) auto;\n      gap: 24px;\n      align-items: center;\n      padding: 30px;\n      border: 1px solid var(--epw-line);\n      border-radius: 18px;\n    }\n\n    .epw-cta-box h2 {\n      margin: 0 0 8px;\n      font-size: clamp(1.45rem, 2.5vw, 2rem);\n    }\n\n    .epw-cta-box p {\n      margin: 0;\n      color: var(--epw-muted);\n    }\n\n    .epw-cta {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 48px;\n      padding: 0 18px;\n      border-radius: 10px;\n      background: var(--epw-red);\n      color: var(--epw-white);\n      text-decoration: none;\n      font-weight: 800;\n      white-space: nowrap;\n    }\n\n    .epw-cta:hover,\n    .epw-cta:focus-visible {\n      background: var(--epw-red-dark);\n      outline: none;\n    }\n\n    @media (max-width: 900px) {\n      .epw-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n      .epw-usecase-grid { grid-template-columns: repeat(2, minmax(0,1fr)); }\n      .epw-cta-box { grid-template-columns: 1fr; }\n    }\n\n    @media (max-width: 620px) {\n      .epw-hero { padding: 54px 20px 48px; }\n      .epw-main { padding: 42px 18px 58px; }\n      .epw-grid,\n      .epw-usecase-grid { grid-template-columns: 1fr; }\n      .epw-usecases { padding: 24px; }\n      .epw-cta { width: 100%; }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
